import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getLandlordDeals } from './deals-dashboard.api';
import type { GetLandlordDealsPaginationResponseData } from './application.types';
import { dealsTableKeys, type DealsCountQuery } from './deals-table.query-keys';

export const useFetchPaginatedCount = (query: DealsCountQuery) => {
  const { data, isLoading, isFetching, isPlaceholderData, error } = useQuery({
    // The total ignores page, cursor and sort, so paging never refetches this (expensive) count.
    queryKey: dealsTableKeys.count(query),
    queryFn: (): Promise<GetLandlordDealsPaginationResponseData> =>
      getLandlordDeals(
        query.tab,
        // No page size: the total doesn't depend on it, so rows-per-page changes reuse it.
        0,
        null,
        query.search,
        query.selectedStatus,
        query.selectedBuildings,
        true,
        query.leaseFilters,
        undefined,
        undefined,
        query.renewalOpportunityStatus,
        query.includeExpiredDeals,
      ),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    error,
    isFetching,
    isPlaceholderData,
  };
};
